import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from '../redux/cart/actions';
import { decreaseQuantity } from '../redux/products/actions';

function ProductItem() {
    //Hooks
    const products = useSelector((state) => state.products.products);
    const dispatch = useDispatch();

    //Functions
    const handleAddToCart = (id) => {
        dispatch(addToCart(id));
        dispatch(decreaseQuantity(id));
    }


    //JSX
    return (
        products.length > 0 ? (
            products.map((product) => {
                const { id, name, category, imgURL, price, quantity } = product;
                return (
                    <div className="lws-productCard" key={id}>
                        <img className="lws-productImage" src={imgURL} alt="product" />
                        <div className="p-4 space-y-2">
                            <h4 className="lws-productName">{name}</h4>
                            <p className="lws-productCategory">{category}</p>
                            <div className="flex items-center justify-between pb-2">
                                <p className="productPrice">BDT <span className="lws-price">{price}</span></p>
                                <p className="productQuantity">QTY <span className="lws-quantity">{quantity}</span></p>
                            </div>
                            <button className="lws-btnAddToCart" disabled={quantity <= 0} onClick={() => handleAddToCart(id)}>Add To Cart</button>
                        </div>
                    </div>
                )
            })
        ) : (<h1>No Products Found!</h1>)
    )
}

export default ProductItem